import React, { useRef } from "react";
import SEO from "../Components/SEO";
import Card2 from "../Images/Headers/publicity_2.jpg";
import "./NewsandEvents.css";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import { Link, useLocation, useHistory } from "react-router-dom";

const ITEMS_PER_PAGE = 9;

/* ─── News data ───────────────────────────────────────── */
const NEWS_ITEMS = [
  {
    id: 1,
    title: "Celebrating World Wetlands Day",
    date: "2024-02-02",
    slug: "/Celebrating-World-Wetlands-Day",
  },
  {
    id: 2,
    title: "Agricultural Thematic Area Changing the Office Landscape",
    date: "2024-02-22",
    slug: "/Agricultural-Thematic-Area-Changing-the-Office-Landscape",
  },
  {
    id: 3,
    title:
      "CIRCODU Laboratory a Leader in Testing Cookstoves for Efficiency, Safety, Durability, and Emissions",
    date: "2024-05-31",
    slug: "/CIRCODU-Laboratory-a-Leader-in-Testing-Cookstoves-for-Efficiency-Safety-Durability-and-Emissions",
  },
  {
    id: 4,
    title:
      "Monitoring for International Energy Investment Organisation (E+CO) Cookstove Programme — Tanzania",
    date: "2010-12-01",
    slug: "/Monitoring-for-International-Energy-Investment-Organisation-E+CO-Cookstove-Programme-Tanzania",
  },
  {
    id: 5,
    title: "Testing of BioLite Cookstoves at the CIRCODU Cookstove Laboratory",
    date: "2024-07-31",
    slug: "/Testing-of-BioLite-Cookstoves-at-the-CIRCODU-Cookstove-Laboratory",
  },
  {
    id: 6,
    title:
      "From Lab to Field: Advancing Regional Collaboration in Clean Cooking!",
    date: "2025-09-03",
    slug: "/From-Lab-to-Field-Advancing-Regional-Collaboration-in-Clean-Cooking",
  },
  {
    id: 7,
    title:
      "Training in Progress | Schools Kitchen and Cooking Study (SKACS) Project – Uganda",
    date: "2026-02-05",
    slug: "/Training-in-Progress-Schools-Kitchen-and-Cooking-Study-SKACS-Project-Uganda",
  },
  {
    id: 8,
    title: "Advancing Standards for Clean Cooking in Uganda",
    date: "2026-02-19",
    slug: "/Advancing-Standards-for-Clean-Cooking-in-Uganda",
  },
  {
    id: 9,
    title:
      "Sensitization and Validation Workshop on National Standards for Institutional Cookstoves and Institutional Biogas Systems",
    date: "2026-02-25",
    slug: "/Sensitization-and-Validation-Workshop-on-National-Standards-for-Institutional-Cookstoves-and-Institutional-Biogas-Systems",
  },
  {
    id: 10,
    title:
      "Third-Party Independent Monitoring and Evaluation for the Uganda Efficient Stove Program",
    date: "2020-02-18",
    slug: "/Third-Party-Independent-Monitoring-and-Evaluation-for-the-Uganda-Efficient-Stove-Program",
  },
  {
    id: 11,
    title:
      "Uganda Moves Towards Efficient Use of Electricity for Cooking — A National eCooking Strategy Takes Shape",
    date: "2024-01-26",
    slug: "/Uganda-Moves-Towards-Efficient-Use-of-Electricity-for-Cooking-A-National-eCooking-Strategy-Takes-Shape",
  },
  {
    id: 12,
    title:
      "Training of Trainers on Briquette and Energy Efficient Cookstove Production for PELUM Uganda Affiliates",
    date: "2023-09-29",
    slug: "/Training-of-Trainers-on-Briquette-and-Energy-Efficient-Cookstove-Production-for-PELUM-Uganda-Affiliates",
  },
  {
    id: 13,
    title:
      "Novel Sales Pilot Study — University of California, Berkeley and Innovations for Poverty Action",
    date: "2011-11-01",
    slug: "/Novel-Sales-Pilot-Study-University-of-California-Berkeley-and-Innovations-for-Poverty-Action",
  },
  {
    id: 14,
    title:
      "Third-Party Independent Monitoring for the Uganda Energy Efficient Stoves Programme (Impact Carbon)",
    date: "2014-09-01",
    slug: "/Third-Party-Independent-Monitoring-for-the-Uganda-Energy-Efficient-Stoves-Programme-Impact-Carbon",
  },
  {
    id: 15,
    title:
      "Monitoring for Uganda Energy Efficient Stoves (Berkeley Air Monitoring Group)",
    date: "2015-04-01",
    slug: "/Monitoring-for-Uganda-Energy-Efficient-Stoves-Berkeley-Air-Monitoring-Group",
  },
  {
    id: 16,
    title: "Baseline Fuel Consumption Study — Gulu, Mbarara and Kampala",
    date: "2010-06-01",
    slug: "/Baseline-Fuel-Consumption-Study-Gulu-Mbarara-and-Kampala",
  },
  {
    id: 17,
    title:
      "Provision of Training in Bio-Briquette Production — West Nile, Karamoja, and Rwenzori Regions (ENABEL)",
    date: "2019-08-01",
    slug: "/Provision-of-Training-in-Bio-Briquette-Production-West-Nile-Karamoja-and-Rwenzori-Regions-ENABEL",
  },
  {
    id: 18,
    title: "Energy Access Baseline Study — Kasese District",
    date: "2013-11-01",
    slug: "/Energy-Access-Baseline-Study-Kasese-District",
  },
  {
    id: 19,
    title:
      "Testing of Institutional Improved Cookstoves — GVEP International CARE Project",
    date: "2014-04-01",
    slug: "/Testing-of-Institutional-Improved-Cookstoves-GVEP-International-CARE-Project",
  },
  {
    id: 20,
    title:
      "Household eCooking Study — Energy Implications of Cooking Entirely with Electricity",
    date: "2023-01-14",
    slug: "/Household-eCooking-Study-Energy-Implications-of-Cooking-Entirely-with-Electricity",
  },
  {
    id: 21,
    title: "Gold Standard PoA Monitoring — Impact Carbon (2023)",
    date: "2023-08-01",
    slug: "/Gold-Standard-PoA-Monitoring-Impact-Carbon-2023",
  },
  {
    id: 22,
    title:
      "Carbon Monitoring and Biogas User Surveys — African Biogas Carbon Programme (2018–2025)",
    date: "2025-12-01",
    slug: "/Carbon-Monitoring-and-Biogas-User-Surveys-African-Biogas-Carbon-Programme",
  },
  {
    id: 23,
    title: "Gold Standard PoA Monitoring — Impact Water",
    date: "2025-05-01",
    slug: "/Gold-Standard-PoA-Monitoring-Impact-Water",
  },
  {
    id: 24,
    title:
      "In-Home Greenhouse Gas Emissions Testing — Rocket and Traditional Stoves, Ruhiira Uganda",
    date: "2010-01-11",
    slug: "/In-Home-Greenhouse-Gas-Emissions-Testing-Rocket-and-Traditional-Stoves-Ruhiira-Uganda",
  },
  {
    id: 25,
    title:
      "Clean Cooking Energy Needs Assessment — Public and Private Institutions (MEMD / World Bank)",
    date: "2023-06-01",
    slug: "/Clean-Cooking-Energy-Needs-Assessment-Public-and-Private-Institutions-MEMD-World-Bank",
  },
  {
    id: 26,
    title: "Consumer Testing of Key Fact Documents for Cookstoves — GIZ Uganda",
    date: "2014-08-01",
    slug: "/Consumer-Testing-of-Key-Fact-Documents-for-Cookstoves-GIZ-Uganda",
  },
  {
    id: 27,
    title:
      "KPT Training Support — Kenya and Cambodia (Berkeley Air Monitoring Group, 2025)",
    date: "2025-02-01",
    slug: "/KPT-Training-Support-Kenya-and-Cambodia-Berkeley-Air-Monitoring-Group-2025",
  },
  {
    id: 28,
    title:
      "Leading Integrated Research for Agenda 2030 in Africa (LIRA 2030) — Indoor Air Quality Study",
    date: "2019-03-01",
    slug: "/Leading-Integrated-Research-for-Agenda-2030-in-Africa-LIRA-2030-Indoor-Air-Quality-Study",
  },
  {
    id: 29,
    title:
      "Supporting 20 District Local Governments on Energy Planning — Albertine Graben",
    date: "2020-05-01",
    slug: "/Supporting-20-District-Local-Governments-on-District-Level-Energy-Planning-Albertine-Graben",
  },
  {
    id: 30,
    title:
      "Socio-Economic Study and Energy Access Baseline — Arua and Masindi Districts",
    date: "2017-01-11",
    slug: "/Socio-Economic-Study-and-Energy-Access-Baseline-Arua-and-Masindi-Districts",
  },
  {
    id: 31,
    title:
      "MECS Uganda Schools eCooking Programme — Transitioning Schools from Biomass to Electric Cooking",
    date: "2024-10-01",
    slug: "/MECS-Uganda-Schools-eCooking-Programme-Transitioning-Schools-from-Biomass-to-Electric-Cooking",
  },
  {
    id: 32,
    title:
      "Baseline Study — Social, Cultural and Economic Conditions in Rural Mbale (HIVOS Clean Air Zone Uganda)",
    date: "2018-12-01",
    slug: "/Baseline-Study-Social-Cultural-and-Economic-Conditions-in-Rural-Mbale-HIVOS-Clean-Air-Zone-Uganda",
  },
  {
    id: 33,
    title:
      "Feasibility Assessment for an Improved Cookstoves Carbon Offset Project — Mt. Elgon Region",
    date: "2013-10-01",
    slug: "/Feasibility-Assessment-for-an-Improved-Cookstoves-Carbon-Offset-Project-Mt-Elgon-Region",
  },
  {
    id: 34,
    title: "National Charcoal Survey for Uganda",
    date: "2016-06-01",
    slug: "/National-Charcoal-Survey-for-Uganda",
  },
  {
    id: 35,
    title:
      "Behavioural Change Interventions in Cookstove Adoption — Mbarara District",
    date: "2012-12-01",
    slug: "/Behavioural-Change-Interventions-in-Cookstove-Adoption—Mbarara-District",
  },
  {
    id: 36,
    title: "eCooking Baseline Study and National eCooking Strategy for Uganda",
    date: "2023-09-01",
    slug: "/eCooking-Baseline-Study-and-National-eCooking-Strategy-for-Uganda",
  },
  {
    id: 37,
    title:
      "Policy Brief — Energy Efficiency Opportunities in Agri-Business Value Chains (PSFU)",
    date: "2023-07-01",
    slug: "/Policy-Brief-Energy-Efficiency-Opportunities-in-Agri-Business-Value-Chains-PSFU",
  },
  {
    id: 38,
    title:
      "Biomass Energy Initiative for Africa (BEIA) — TLUD Gasifier Stove Study, Uganda",
    date: "2012-05-01",
    slug: "/Biomass-Energy-Initiative-for-Africa-BEIA-TLUD-Gasifier-Stove-Study-Uganda",
  },
  {
    id: 39,
    title:
      "Market Intelligence Study for the Improved Cookstove Subsector in Uganda — SNV",
    date: "2022-08-01",
    slug: "/Market-Intelligence-Study-for-the-Improved-Cookstove-Subsector-in-Uganda-SNV",
  },
  {
    id: 40,
    title:
      "Assessment of Business Case for Household Bio-Digesters — Uganda (BSUL)",
    date: "2019-12-01",
    slug: "/Assessment-of-Business-Case-for-Household-Bio-Digesters-Uganda-BSUL",
  },
  {
    id: 41,
    title:
      "Gold Standard PoA Monitoring — Supporting Uganda's Emerging Clean Cooking Enterprises",
    date: "2024-10-01",
    slug: "/Gold-Standard-PoA-Monitoring-Supporting-Ugandas-Emerging-Clean-Cooking-Enterprises",
  },
  {
    id: 42,
    title: "Gold Standard PoA Monitoring — BioLite Cookstoves (2023 – Ongoing)",
    date: "2023-01-20",
    slug: "/Gold-Standard-PoA-Monitoring-BioLite-Cookstoves",
  },
  {
    id: 43,
    title:
      "Baseline Study and KPT Survey — Improved Cookstoves and Water Treatment Filters (Climate Secure India)",
    date: "2021-12-20",
    slug: "/Baseline-Study-and-KPT-Survey—Improved-Cookstoves-and-Water-Treatment-Filters-Climate-Secure-India",
  },
  {
    id: 44,
    title:
      "Training Services on Briquette and Cookstove Production to PELUM Uganda affiliated smallholder farmers",
    date: "2024-07-31",
    slug: "/Training-Services-on-Briquette-and-Cookstove-Production-to-PELUM-Uganda-affiliated-smallholder-farmers",
  },
  {
    id: 45,
    title:
      "Independent Verification and Results Monitoring — Uganda Clean Cooking Supply Chain Expansion Project (UCCSCEP)",
    date: "2020-12-12",
    slug: "/Independent-Verification-and-Results-Monitoring-Uganda-Clean-Cooking-Supply-Chain-Expansion-Project-UCCSCEP",
  },
  {
    id: 46,
    title: "Baseline KPT Surveys — CO2balance Uganda",
    date: "2022-07-01",
    slug: "/Baseline-KPT-Surveys-CO2balance-Uganda",
  },
  {
    id: 47,
    title:
      "Monitoring for Improved Cookstove Carbon Projects — UpEnergy (2011 – Ongoing)",
    date: "2026-01-20",
    slug: "/Monitoring-for-Improved-Cookstove-Carbon-Projects-UpEnergy-2011-Ongoing",
  },
  {
    id: 48,
    title:
      "Willingness to Pay and Consumer Acceptance Assessment for Clean Cooking in Uganda — World Bank",
    date: "2015-08-01",
    slug: "/Willingness-to-Pay-and-Consumer-Acceptance-Assessment-for-Clean-Cooking-in-Uganda-World-Bank",
  },
  {
    id: 49,
    title:
      "Mid-Term Review — Renewable Energy Projects, Energy, Climate and Extractives Programme (WWF Uganda)",
    date: "2018-10-01",
    slug: "/Mid-Term-Review-Renewable-Energy-Projects-Energy-Climate-and-Extractives-Programme-WWF-Uganda",
  },
  {
    id: 50,
    title:
      "Baseline Study on Pre-Project Fuel Consumption — Dutch Spark for Clean Cooking Solutions",
    date: "2023-01-10",
    slug: "/Baseline-Study-on-Pre-Project-Fuel-Consumption-Dutch-Spark-for-Clean-Cooking-Solutions",
  },
];

/* ─── Single card ─────────────────────────────────────── */
function NewsCard({ item }) {
  const displayDate = new Date(item.date).toLocaleDateString("en-UG", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <div className="ne-card">
      <div className="ne-card__body">
        <h3 className="ne-card__title">
          <Link
            to={item.slug}
            onClick={scrollToTop}
            aria-label={`Read more about ${item.title}`}
          >
            {item.title}
          </Link>
        </h3>
      </div>
      <div className="ne-card__right">
        <div className="ne-card__meta">
          <span className="ne-card__meta-dot" />
          <span className="ne-card__meta-text">{displayDate}</span>
        </div>
        <div className="ne-card__footer">
          <Link
            to={item.slug}
            className="ne-card__btn"
            onClick={scrollToTop}
            aria-label={`Read more about ${item.title}`}
          >
            Read More <span className="ne-card__btn-arrow">→</span>
          </Link>
        </div>
      </div>
    </div>
  );
}

/* ─── Pagination bar ──────────────────────────────────── */
function Pagination({ current, total, onChange }) {
  if (total <= 1) return null;
  const pages = Array.from({ length: total }, (_, i) => i + 1);
  const visible = pages.filter(
    (p) => p === 1 || p === total || Math.abs(p - current) <= 1,
  );
  const withEllipsis = [];
  visible.forEach((p, i) => {
    if (i > 0 && p - visible[i - 1] > 1) withEllipsis.push("...");
    withEllipsis.push(p);
  });

  return (
    <nav className="ne-pagination" aria-label="News pagination">
      <button
        className="ne-pagination__btn ne-pagination__btn--nav"
        onClick={() => onChange(current - 1)}
        disabled={current === 1}
      >
        ←
      </button>
      {withEllipsis.map((item, i) =>
        item === "..." ? (
          <span key={`ellipsis-${i}`} className="ne-pagination__ellipsis">
            …
          </span>
        ) : (
          <button
            key={item}
            className={`ne-pagination__btn${item === current ? " ne-pagination__btn--active" : ""}`}
            onClick={() => onChange(item)}
          >
            {item}
          </button>
        ),
      )}
      <button
        className="ne-pagination__btn ne-pagination__btn--nav"
        onClick={() => onChange(current + 1)}
        disabled={current === total}
      >
        →
      </button>
    </nav>
  );
}

/* ─── Page component ──────────────────────────────────── */
function NewsandEvents() {
  const location = useLocation();
  const history = useHistory();

  const queryParams = new URLSearchParams(location.search);
  const currentPage = parseInt(queryParams.get("page") || "1", 10);

  const gridRef = useRef(null);

  const sortedNews = [...NEWS_ITEMS].sort(
    (a, b) => new Date(b.date) - new Date(a.date),
  );

  const totalPages = Math.ceil(sortedNews.length / ITEMS_PER_PAGE);
  const start = (currentPage - 1) * ITEMS_PER_PAGE;
  const pageItems = sortedNews.slice(start, start + ITEMS_PER_PAGE);

  const showComingSoon =
    currentPage === totalPages && pageItems.length < ITEMS_PER_PAGE;

  const handlePageChange = (page) => {
    history.push({
      pathname: location.pathname,
      search: `?page=${page}`,
    });

    if (gridRef.current) {
      gridRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <div className="ne-page">
      <SEO
        title="News and Events"
        description="Stay updated with the latest news and events from CIRCODU Uganda, including project updates, research findings, and upcoming initiatives in clean energy, clean cooking, energy research, carbon monitoring, and community development across East Africa."
        keywords="CIRCODU news, clean cooking Uganda, cookstove testing, carbon monitoring, energy research Uganda, community development"
        url="/publicity/news-and-events"
      />

      <div className="ne-hero">
        <div className="ne-hero__image">
          <img src={Card2} alt="News and Events Header" />
        </div>
        <div className="ne-hero__overlay">
          <h4 className="ne-hero__title">News &amp; Events</h4>
          <Breadcrumb>
            <Breadcrumb.Item className="text1" href="/">
              Home
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">Publicity</Breadcrumb.Item>
            <Breadcrumb.Item className="text1">
              News &amp; Events
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>

      <section className="ne-section border-bottom">
        <div className="container border-top pt-3">
          <p className="ne-page-count">
            Showing{" "}
            <strong>
              {start + 1}–{Math.min(start + ITEMS_PER_PAGE, sortedNews.length)}
            </strong>{" "}
            of <strong>{sortedNews.length}</strong> articles
          </p>

          <div className="ne-grid" ref={gridRef}>
            {pageItems.map((item) => (
              <NewsCard key={item.id} item={item} />
            ))}

            {showComingSoon && (
              <div className="ne-card ne-card--muted">
                <div className="ne-card__body">
                  <h3 className="ne-card__title">
                    <span>Coming Soon</span>
                  </h3>
                </div>
                <div className="ne-card__right">
                  <div className="ne-card__meta">
                    <span className="ne-card__meta-dot" />
                    <span className="ne-card__meta-text">—</span>
                  </div>
                  <div className="ne-card__footer">
                    <span className="ne-card__btn">Read More →</span>
                  </div>
                </div>
              </div>
            )}
          </div>

          <Pagination
            current={currentPage}
            total={totalPages}
            onChange={handlePageChange}
          />
        </div>
      </section>
    </div>
  );
}

export default NewsandEvents;
